import ScriptingEffect from './ScriptingEffect.js';
import {r_trig} from './trig.js';
import {fig, t_transform_fig} from './t_figure.js';
import {t_double} from './t_double.js';
import {atranspose} from './utils.js';
import {noDissonance} from './harmony.js';
import {slide} from './slide.js';
import {dot, dash} from '../tidal/parser.js';
import {fetchMelody} from './melody.js';
import {jaki_accent, apply_rules} from './jaki.js';
import {decisions, t_syncopate, t_simplify, t_generate} from './tgenerate.js';
import {before, otherwise, when, after, LEGATO, FLAM, ACCENT, DOUBLE, STACCATO, PIANISSIMO, PIANO, REST, rules} from './trules.js';
import {t_every, isNewCycle, t_variation, play_and_vary} from './tevery.js';
import {
    t_keep_leaves,
    t_transform,
    t_splice,
    t_map,
    t_multiply,
    t_transform_leaf,
    t_staccato,
    t_accent,
    t_append,
    t_interleave,
    t_interleave_before,
    t_operator,
    t_nth,
    t_leaf,
    isRest,
    isAccent,
    isStaccato,
    isLeaf,
    t_swap,
    t_replace,
    t_len,
    t_insert} from './tlist.js';
import {or, and} from './bool.js';
import {invert} from './invert.js';
import {graphic, draw, erase} from './graphics.js';
import {doc} from './documentation.js';
import {augment} from './augment.js';
import {t_put_scale, scl, degree_chord, invert_chord, scale_degree} from './t_harmony.js';
import {altList, t_sublist, t_reverse, list, append, rconcat, concat, sublist, vectorAdd, len, car, cdr, map, nth} from './list.js';
import {search} from './search.js';
import {loop} from './loop.js';
import {sparse} from './sparse.js';
import {time} from './time.js';
import {resolution} from './resolution.js';
import {t_trigger, triggerAttack, triggerAttackRelease, triggerRelease} from './triggerAttackRelease.js';
import {getScriptForTitleSync} from 'decentralized/scripting/scripting.js';
import {add, multiply, mod} from './lazy.js';
import {print} from './log.js';
import {once} from './once.js';
import {counter} from './counter.js';
import {harmonize, chord, strum} from './harmonize.js';
import {stretch} from './stretch.js';
import {setScriptVariables} from 'actions/index.js';
import {pipe} from './pipe.js';
import {send, receive, t_send, t_receive} from './msg.js';
import {threshold} from './threshold.js';
import {delay} from './delay.js';
import {range} from './array.js';
import {hand, t_print, t_cond, tidal, j_tidal, tparse} from './tidal.js';
import {poly} from './poly.js';
import {lte, gte} from './compare.js';
import {density} from './density.js';
import {scale} from './scale.js';
import {
    setMacro,
    choke,
    env1
,
    switchOutput,
    env2,
    env3,
    env4,
    s,
    notes,
    steps,
    rolling,
    reverse,
    p,
    prob,
    cond,
    set,
    get,
    patternSwitch,
    start,
    on,
    grab,
    grabTime,
    randomSelect,
    transpose,
    filter,
    trigger,
    vel,
    dur,
    chop,
    lazy
} from './lang.js';
import {repeat, beat, gate, shift} from './beat.js';
import {alt, r_alt, altn, t_alt, t_altn, every} from './alt.js';
import {acc} from './accumulate.js';

const {Parser} = require("acorn");

class UserScriptEffect extends ScriptingEffect {
    constructor(track) {
        super("User Script", track);
        this.logs = [];
        this.code = "";
        this.clear();
        this.numberOfOutputs = 2;
    }

    isRealTime() { return true; }

    get documentation() {
        return [
            "Write scripts for transforming triggers, and create your own custom midi-effects."
        ];
    }

    getContext() {
        return {
            setMacro,
            env1,
            search,
            sparse,
            once,
            time,
            and,
            or,
            resolution,
            env2,
            engine: this.track.sequencerEngine,
            env3,
            hand,

            rules,
            env4,
            doc,
            choke,
            noDissonance,
            alt,
            r_alt,
            invert_chord,
            degree_chord,
            scale_degree,
            t_operator,
            dot,
            dash,
            when,
            before,
            otherwise,
            t_syncopate,
            t_leaf,
            t_transform_leaf,
            t_nth,
            t_swap,
            t_replace,
            t_accent,
            t_staccato,
            t_every,
            scl,
            t_put_scale,
            isLeaf,
            t_map,
            t_generate,
            t_append,
            t_cond,
            t_splice,
            t_transform,
            t_multiply,
            t_keep_leaves,
            isRest,
            isStaccato,
            isAccent,
            jaki_accent,
            altn,
            t_reverse,
            t_variation,
            play_and_vary,
            tidal,
            j_tidal,
            tparse,
            density,
            decisions,
            augment,
            atranspose,
            gte,
            lte,
            every,
            lazy,
            nth,
            scale,
            t_insert,
            t_interleave,
            t_interleave_before,
            car,
            t_send,
            t_receive,
            cdr,
            loop,
            len,
            t_len,
            t_every,
            t_double,
            isNewCycle,
            sublist,
            t_sublist,
            t_print,
            slide,
            concat,
            apply_rules,
            cat: concat,
            t_altn,
            t_alt,
            list,
            l: list,
            vectorAdd,
            append,
            map,
            stretch,
            floor: Math.floor,
            round: Math.round,
            draw,
            erase,
            random: Math.random,
            print,
            acc,
            reverse,
            s,
            pipe,
            set,
            filter,
            trigger,
            r_trig,
            harmonize,
            chord,
            rconcat,
            multiply,
            add,
            mod,
            t_simplify,
            counter,
            start,
            fetchMelody,
            poly,
            receive,
            grab,
            on,
            patternSwitch,
            send,
            grabTime,
            steps,
            gate,
            range,
            shift,
            beat,
            notes,
            rolling,
            invert,
            cond,
            get,
            repeat,
            prob,
            randomSelect,
            threshold,
            transpose,
            strum,
            t_trigger,
            triggerAttack,
            triggerRelease,
            triggerAttackRelease,
            load: (name) => this.loadScript(name),
            library: (name) => this.loadScript(name, ""),
            p,
            switchOutput,
            vel,
            delay,
            dur,
            chop,
            altList,
            f3: tparse('. -'),
            f4: tparse('. . -'),
            f5a: tparse('. . . -'),
            f5b: tparse('- . -'),
            f5c: tparse('. - -'),
            fig,
            t_transform_fig,
            before, when, after, FLAM, LEGATO, ACCENT, STACCATO, PIANISSIMO, REST, PIANO, DOUBLE, // rules
            knob: (name, val, min=0, max=16) =>
                {
                    let v = this.newVar(name, val, min, max);
                    return () => {
                        let _var = this[name+'Parameter'];
                        let ret = _var.get();
                        return ret;
                    };
                },
        };
    }

    evalWithContext(str, func="pipe") {
        let parseCode = '';
        try {
            let pieces = str.split(";");
            let last = pieces[pieces.length - 1];
            let preamble = pieces.slice(0, pieces.length - 1).join(";");
            let code = "with(this) { " +
                preamble + "; return " + func + "(" + last + ")}";
            parseCode = 
                preamble + ";\n\n\n " + func + "(" + last + ")";

            return (new Function(code)).call(this.getContext());
        } catch (e) {
            let a_str = "<anonymous>:"
            let anon = e.stack.indexOf(a_str);
            let after = e.stack.slice(anon + a_str.length).split(":")[0];
            let lineNumber = parseInt(after);
            if (isNaN(lineNumber)) {
                try {
                    Parser.parse(parseCode);
                } catch(err) {
                    this.syntaxErrorLine = err.loc.line ;
                }
            } else {
                this.syntaxErrorLine = lineNumber - 2;
            }
            return undefined;
        }
    }

    loadScript(name, func="s") {
        // first synchronusly get the script w/ title=name
        let code = getScriptForTitleSync(name);

        // then evaluate
        let ctxt = this.evalWithContext(code, func);

        // return the ctxt
        if (func==="") {
            return ctxt;
        }
        return () => ctxt; 
    }

    hasSyntaxError(str) {
        return this.evalWithContext(str) === undefined;
    }

    eval(str, free=true, freeAfter=false) {
        if (free) {
            this.freeTidals();
        }
        let values = this.clearVariables();
        let myScript = this.evalWithContext(str);
        if (myScript === undefined) {
            this.hasError = true;
        } else {
            this.myScript = myScript;
            
            // run output() to force any variables to be
            // set
            this.output();

            this.myScript = this.evalWithContext(str);

            this.hasError = false;
            this.code = str;
        }

        for (let name in values) {
            if (this[name + 'Parameter']) {
                this[name + 'Parameter'].copyFrom(
                    values[name], this.track.sequencerEngine);
            } 
        }
        if (freeAfter) {
            this.freeTidals();
        }
        this.updateVariablesRedux();
    }

    clear() {
        if (this.tidals) {
            this.tidals.forEach(
                t => t.clear());
        }
        this.freeTidals();
    }

    stop() {
        super.stop();
        if (this.code === '') {
            return;
        }
        this.eval(this.code);
        this.freeTidals();
    }

    getCopy(track, ignoreId=true) {
        let fx = new UserScriptEffect(track);
        fx.fromJson(this.getJson(), ignoreId);
        return fx;
    }

    getJson() {
        return {
            ... super.getJson(),
            expanded: this.expanded,
            code: this.code
        };
    }

    fromJson(json, isCopy) {
        this.code = json.code;
        this.expanded = json.expanded;
        if (this.code === '') {
            return;
        }
        this.eval(this.code);
        this.freeTidals();
        super.fromJson(json, isCopy);
    }

}

export default UserScriptEffect;
